import { QUERY_PRODUCTS_OPERATION } from './storefrontClientGraphQL'
import Client from './client'
import { GetProductsQuery } from 'types/storefront.generated'

const fetchShopifyProductDetail = async () => {
  const { data } = await Client.request<GetProductsQuery>(QUERY_PRODUCTS_OPERATION)
  if (data?.products?.edges) {
    return data?.products.edges.map((edge) => edge.node)
  } else {
    return []
  }
}

export default fetchShopifyProductDetail
